module.exports = __webpack_public_path__ + "img/authorlogo.f23714fe.png";